import layout from '@/views/layout/layout.vue'
const memberList = r => require.ensure([], () => r(require('@/views/ywt/member/list.vue')), 'group-ywt-member')

const ywtMember = [
  {
    path: '/ywt/member',
    name: 'ywt-member',
    component: layout,
    redirect: '/ywt/member/list',
    children: [
      {
        path: 'list',
        name: 'ywt-member-list',
        component: memberList,
        meta: {
          displayName: '工程师管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default ywtMember



// WEBPACK FOOTER //
// ./src/router/ywt/member.js